// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import globalDataReducer from './globalDataSlice';
import authReducer from './authSlice';
import appReducer from './appSlice';
import { loadActiveAccountId } from '../utils/persist';
const savedActive = loadActiveAccountId();
const preloadedState = savedActive
  ? { globalData: { activeAccountId: savedActive, initialized: true } }
  : undefined;

export const store = configureStore({
  reducer: {
    auth: authReducer,        
    app: appReducer,          
    globalData: globalDataReducer,
    preloadedState
  },
});